<template>
    <div :class="[FlexRow ? 'tw-flex-col lg:tw-flex-row' : 'tw-flex-col', FlexReverse ? 'md:tw-flex-row-reverse tw-justify-between' : '', 'tw-flex', 'tw-w-full', 'tw-font-light']">
      <img :class="FlexRow ? 'flex_event_image' : 'event_image'" :src="'/storage/events/'+image" :alt="title" class="tw-w-full" style="{height: 100%;}">
      <div :class="[FlexRow ? 'tw-pl-3' : 'tw-pl-0', 'tw-flex', 'tw-flex-col']">
        <div class="tw-text-xs tw-pt-4 sm:tw-pt-3">{{ date }}</div>
        <a v-if="link!='#'" :href="link">
            <div class="tw-text-4xl tw-underline tw-uppercase tw-pt-2 tw-pb-4 sm:tw-pb-6 tw-overflow-hidden">{{ title }}</div>
        </a>
        <div v-else class="tw-text-4xl tw-uppercase tw-pt-2 tw-pb-4 sm:tw-pb-6 tw-overflow-hidden">{{ title }}</div>
        <div class="tw-text-xl tw-pb-3" v-html="content"></div>
        <a v-if="link!='#'" :href="link" class="tw-text-black tw-underline tw-uppercase tw-text-xs tw-font-normal text-link">Read More</a>
      </div>
    </div>
</template>
<script>
export default {
    name: 'HomeNewsArticle',
    props: {
        image: String,
        title: String,
        date: String,
        content: String,
        link: String,
        FlexRow: {
            type: Boolean,
            default: false,
        },
        FlexReverse: {
            type: Boolean,
            default: false,
        },
    },
  computed: {
  },
};
</script>
<style scoped>
a {
    color: #000;
    width: fit-content;
}
.event_image {

}
@screen lg {
    .flex_event_image {
        max-width: 40%;
    }
}
</style>
